import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { Modal, ModalBody, ModalHeader, Paragraph, Spacer } from '@ui-kit'
import { useEffect } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Row } from 'simple-flexbox'

import styles from './ModalPayPal.module.scss'

export const PayPalModal = NiceModal.create(
  ({
    button
  }: {
    button: {
      render: (selector: string) => void
    }
  }) => {
    const { t } = useTranslation()
    const { remove, visible } = useModal()

    useEffect(() => {
      if (visible) {
        button?.render('#paypal-button')
      }
    }, [visible])

    return (
      <Modal onClick={remove} onClose={remove} size={850}>
        <ModalHeader heading={t('modal.paypal.heading')} />

        <ModalBody>
          <Paragraph size={16}>
            <Trans i18nKey='modal.paypal.description' />
          </Paragraph>

          <Spacer space={20} />

          <Row justifyContent='flex-end'>
            <div id='paypal-button' className={styles['paypal-button']} />
          </Row>
        </ModalBody>
      </Modal>
    )
  }
)

PayPalModal.displayName = 'PaypalModal'
